import { type Address, getAddress } from "viem"

export const RESET_APPROVAL_TOKENS = [
  "0xdAC17F958D2ee523a2206206994597C13D831ec7", // USDT
  "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32", // LIDO
  "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671", // NMR
  "0xd3E4Ba569045546D09CF021ECC5dFe42b1d7f6E4", // MNW
]

export function requiresApprovalReset(token: Address) {
  return RESET_APPROVAL_TOKENS.some(
    (resetToken) => getAddress(resetToken) === getAddress(token),
  )
}
